/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-14T15:25:43.937
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentLeaseContractReceiptPlan,
	getRentLeaseContractReceiptPlanCreateInit,
	getRentLeaseContractReceiptPlanEditInit,
	getRentLeaseContractReceiptPlanView,
	deleteRentLeaseContractReceiptPlan
} from '@api/rentmanage/RentLeaseContractReceiptPlan';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentLeaseContractReceiptPlanCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentLeaseContractReceiptPlanCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentLeaseContractReceiptPlanEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentLeaseContractReceiptPlanEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentLeaseContractReceiptPlan({}, RentLeaseContractReceiptPlan) {
			return new Promise((resolve, reject) => {
				saveRentLeaseContractReceiptPlan(RentLeaseContractReceiptPlan)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentLeaseContractReceiptPlanView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentLeaseContractReceiptPlanView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentLeaseContractReceiptPlan({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentLeaseContractReceiptPlan({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
